import { ReactNode } from 'react';
import { Stack } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { SpacedDash } from '@mews-commander/ui';

interface ActionLogNameProps {
    title: ReactNode;
}

const ActionLogName = ({ title }: ActionLogNameProps) => (
    <Stack itemAlignment="center">
        <span>{title}</span>
        {SpacedDash}
        <LocalizedText textKey={TextKey.ActionLog} />
    </Stack>
);

export default ActionLogName;
